document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.dessert-scroll-grid');
  if (!grid || grid.dataset.arrowsAdded) return;
  grid.dataset.arrowsAdded = 'true';

  var wrapper = document.createElement('div');
  wrapper.style.position = 'relative';
  grid.parentNode.insertBefore(wrapper, grid);
  wrapper.appendChild(grid);

  // Build [clone][originals][clone] so scrolling past either end reveals a duplicate, not a jump
  var originals = Array.from(grid.children);
  var beforeFrag = document.createDocumentFragment();
  var afterFrag = document.createDocumentFragment();
  originals.forEach(function (n) {
    beforeFrag.appendChild(n.cloneNode(true));
    afterFrag.appendChild(n.cloneNode(true));
  });
  grid.insertBefore(beforeFrag, grid.firstChild);
  grid.appendChild(afterFrag);

  var setWidth = 0;
  function measure() {
    setWidth = grid.scrollWidth / 3;
    grid.scrollLeft = setWidth; // start on the middle (real) set
  }
  measure();
  window.addEventListener('resize', measure);

  function getStep() {
    var firstItem = grid.querySelector('.\\#column');
    if (!firstItem) return grid.clientWidth * 0.6;
    var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || '0') || 0;
    return firstItem.getBoundingClientRect().width + gap;
  }

  // After scrolling settles, silently snap back into the middle set if we've drifted into a clone zone
  var settleTimer;
  grid.addEventListener('scroll', function () {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      if (grid.scrollLeft >= setWidth * 2) {
        grid.scrollLeft -= setWidth;
      } else if (grid.scrollLeft <= 0) {
        grid.scrollLeft += setWidth;
      }
    }, 120);
  });

  function makeArrow(direction, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'scroll-arrow scroll-arrow--' + direction;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = direction === 'prev' ? '&#8249;' : '&#8250;';
    btn.addEventListener('click', function () {
      var amount = getStep();
      grid.scrollBy({ left: direction === 'next' ? amount : -amount, behavior: 'smooth' });
    });
    return btn;
  }

  wrapper.appendChild(makeArrow('prev', 'Scroll desserts left'));
  wrapper.appendChild(makeArrow('next', 'Scroll desserts right'));
});